import { useSession } from '@/features/auth';
import { DEFAULT_TRACK, pathForChallengeId } from '@/features/content';
import { useGuestAttempts } from '@/features/guest';
import { useProgress } from '@/features/progress';

const FIRST = 'js-values-output-order';
const SECOND = 'js-values-typeof';

/**
 * Where "Start" goes: signed in -> the current challenge; guests -> 1.2 if 1.1 is already passed (e.g. on the
 * landing card), else 1.1.
 */
export function useStartHref(): string {
  const { status } = useSession();
  const guest = useGuestAttempts();
  const progress = useProgress(DEFAULT_TRACK, status === 'authenticated');

  if (status === 'authenticated') {
    const current = progress.data?.currentChallenge;
    return current ? `/learn/${DEFAULT_TRACK}/${current.chapterSlug}/${current.challengeSlug}` : '/learn';
  }
  const firstDone = guest.some((a) => a.challengeId === FIRST && a.passed);
  return pathForChallengeId(firstDone ? SECOND : FIRST)!;
}
